export default "__VITE_ASSET__H7SHDc2t__"